<div [ngClass]="getBackgroundClass(user)">
  {{getInitials(user)}}
</div>
